import chonkachu from './chonkachu-BAD.json';
import grizzly from './grizzly-GOOD.json';
import nipah from './nipah-BAD.json';
import pigeon from './pigeon-GOOD.json';
import shark from './shark-GOOD.json';
import zap from './zap-BAD.json';
import baszucki from './baszucki-BAD.json';

export interface BacktestStats {
  largestCloseDiffWindowStart: string | null;
  largestVolumeDiffWindowStart: string | null;
  notBuyDecisionClose: number | null;
  notBuyDecisionVolume: number | null;
  adminTotalTweetsBeforeDecision: number;
  adminAverageTweetsBeforeDecision: number;
  modTotalTweetsBeforeDecision: number;
  modAverageTweetsBeforeDecision: number;
  followersOver5000TotalBeforeDecision: number;
  followersOver5000AverageBeforeDecision: number;
  followersOver10000TotalBeforeDecision: number;
  followersOver10000AverageBeforeDecision: number;
  followersOver50000TotalBeforeDecision: number;
  followersOver50000AverageBeforeDecision: number;
  followersOver100000TotalBeforeDecision: number;
  followersOver100000AverageBeforeDecision: number;
  followersOver150000TotalBeforeDecision: number;
  followersOver150000AverageBeforeDecision: number;
  blueVerifiedAuthorsBeforeDecision: number;
  notBuyDecisionTime: string | null;
}

export interface BacktestWindow {
  windowStart: string;
  windowEnd: string;
  tweetCount: number;
  communityTweetCount: number;
  uniqueAuthors: number;
  uniqueAuthorsFollowersOver50000: number;
  uniqueAuthorsFollowersOver100000: number;
  uniqueAuthorsFollowersOver10000: number;
  uniqueAuthorsFollowersOver150000: number;
  newbieAuthors: number;
  blueVerifiedAuthors: number;
  lowFollowerAuthors: number;
  adminTweetCount: number;
  modTweetCount: number;
  modAuthorCount: number;
  newbieRatio: number;
  lowFollowerRatio: number;
  over10000Ratio: number;
  over50000Ratio: number;
  over100000Ratio: number;
  over150000Ratio: number;
  blueVerifiedRatio: number;
  adminTweetRatio: number;
  modTweetRatio: number;
  windowClose: number | null;
  windowVolume: number | null;
}

export interface BacktestPayload {
  stats: BacktestStats;
  windows: BacktestWindow[];
}

export interface BacktestEntry {
  key: BacktestTokenKey;
  label: string;
  data: BacktestPayload;
}

export type BacktestTokenKey =
  | 'pigeon'
  | 'zap'
  | 'grizzly'
  | 'chonkachu'
  | 'shark'
  | 'nipah'
  | 'baszucki';

const rawEntries: Record<BacktestTokenKey, { label: string; data: BacktestPayload }> = {
  pigeon: {
    label: 'Pigeon (GOOD)',
    data: pigeon as BacktestPayload,
  },
  zap: {
    label: 'Zap (BAD)',
    data: zap as BacktestPayload,
  },
  grizzly: {
    label: 'Grizzly (GOOD)',
    data: grizzly as BacktestPayload,
  },
  chonkachu: {
    label: 'Chonkachu (BAD)',
    data: chonkachu as BacktestPayload,
  },
  shark: {
    label: 'Shark (GOOD)',
    data: shark as BacktestPayload,
  },
  nipah: {
    label: 'Nipah (BAD)',
    data: nipah as BacktestPayload,
  },
  baszucki: {
    label: 'Baszucki (BAD)',
    data: baszucki as BacktestPayload,
  },
};

export const backtestEntries: BacktestEntry[] = (Object.entries(
  rawEntries,
) as [BacktestTokenKey, { label: string; data: BacktestPayload }][]).map(
  ([key, entry]) => ({
    key,
    label: entry.label,
    data: entry.data,
  }),
);

export const backtestMap: Record<BacktestTokenKey, BacktestEntry> = backtestEntries.reduce(
  (acc, entry) => {
    acc[entry.key] = entry;
    return acc;
  },
  {} as Record<BacktestTokenKey, BacktestEntry>,
);
